/**
 * Shared layout constants — match the homepage section container padding exactly.
 * Use PAGE_CONTAINER_SX on every <Container> in public marketing pages.
 */

export const PAGE_CONTAINER_SX = {
  px: { xs: 3, sm: 4, md: 6, lg: 20, xl: 20 },
  maxWidth: { xs: '100%', sm: '100%', md: '100%', lg: '1440px', xl: '1600px' },
  mx: 'auto',
};
